import * as React from 'react';
import classNames from 'classnames';

import * as styles from './styles.css';

interface ILinkAreaProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  href: string;
  preventDefault?: boolean;
}

export function LinkArea({ href, children, preventDefault, ...divProps }: ILinkAreaProps) {
  return (
    <div {...divProps} className={classNames(styles['container'], divProps.className)}>
      <a href={href} className={styles['link']}>
        <span className={styles['link-area']} />
      </a>
      {children}
    </div>
  );
}
